/* tslint:disable:max-classes-per-file */
import PjnException from './PjnException';
/**
 * Excepcion generica a lanzar cuando no se puede tirar una mas especifica y
 * la excepcion es local (no a causa del servidor).
 *
 * @export
 * @class ApplicationException
 * @extends {PjnException}
 */
export class ApplicationException extends PjnException {
}
/**
 * Excepcion de validacion local (no por BAD_REQUEST).
 *
 * Incluye la lista de errores a mostrar.
 *
 * @export
 * @class ValidationException
 * @extends {PjnException}
 */
export class ValidationException extends PjnException {
    /**
     * Crea una instancia de ValidationException.
     * @param {string[]} errors lista de errores
     * @memberof ValidationException
     */
    constructor(errors) {
        super('Hubo errores de validación');
        this.errors = errors;
    }
}
//# sourceMappingURL=local.js.map